export function angleToVector(angle = 0) {
    const theta = angle;
    const x = Math.cos(theta);
    const y = Math.sin(theta);
    return {
        x,
        y
    };
}
